import React, { useState } from 'react';
import { ICON } from '../../../icons/iconIds';
import IconButton from '../../icons/IconButton';
import Button from '../../ui/Button';
import {
  copyExportDiagnosticReport,
  formatExportDiagnosticReport,
} from './mediaCreatorExportDiagnostics';

const MediaCreatorExportDiagnosticPanel = ({ diagnostic, onDismiss }) => {
  const [copyState, setCopyState] = useState('idle');
  if (!diagnostic) return null;

  const text = formatExportDiagnosticReport(diagnostic);
  const high = diagnostic.summary?.highSeverity ?? 0;
  const total = diagnostic.summary?.issueCount ?? diagnostic.issues?.length ?? 0;

  const onCopy = async () => {
    try {
      await copyExportDiagnosticReport(diagnostic);
      setCopyState('copied');
      setTimeout(() => setCopyState('idle'), 2500);
    } catch {
      setCopyState('failed');
    }
  };

  return (
    <div className="mc-export-diagnostic" role="region" aria-label="Export diagnostic">
      <div className="mc-export-diagnostic-head">
        <strong>Export diagnostic</strong>
        <span className="dd-muted">
          {total === 0 ? 'No issues flagged' : `${total} issue(s), ${high} high`}
          {' · '}
          {diagnostic.summary?.dataUrlImageCount}/{diagnostic.summary?.imageCount} images as data URLs
        </span>
        <div className="mc-export-diagnostic-actions">
          <Button size="sm" variant="secondary" onClick={onCopy}>
            {copyState === 'copied' ? 'Copied' : copyState === 'failed' ? 'Copy failed' : 'Copy report'}
          </Button>
          {onDismiss && (
            <IconButton icon={ICON.ddClose} onClick={onDismiss} ariaLabel="Dismiss diagnostic" />
          )}
        </div>
      </div>
      <pre className="mc-export-diagnostic-body">{text}</pre>
    </div>
  );
};

export default MediaCreatorExportDiagnosticPanel;
